const SEAT_CATEGORY = 'Seats and Trim';
const SEAT_CAPACITY = 'Max seating capacity';

const getSeats = (equipment) => {
	return equipment
		?.find((_i) => _i.category === SEAT_CATEGORY)
		?.specifications?.find((spec) => spec?.description === SEAT_CAPACITY)
		?.details;
};

const getVehicleType = (vehicle) => {
	const type = vehicle?.type?.toLowerCase();
	if (type === 'new') return 'new';
	if (type === 'used' && vehicle?.certified) return 'certified';
	if (type === 'used') return 'used';
	return null;
};
export const transformVehiclesAttrs = (
	compareAttrs,
	vehicles,
	labels,
	{ showOdometerOnNew } = {}
) => {
	const vehiclesAttrs = new Map();

	compareAttrs.forEach((attribute) => {
		let values = [];
		switch (attribute) {
			case 'LOCATION':
				values = vehicles?.map((vehicle) => {
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'accountName'
						)?.value || ''
					);
				});
				break;
			case 'MILEAGE':
				values = vehicles?.map((vehicle) => {
					if (
						showOdometerOnNew !== 'true' &&
						getVehicleType(vehicle) === 'new'
					) {
						return '';
					}
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'odometer'
						)?.value || ''
					);
				});
				break;
			case 'FUEL_ECONOMY':
				values = vehicles?.map((vehicle) => {
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'fuelEconomy'
						)?.labeledValue || ''
					);
				});
				break;
			case 'TRANSMISSION':
				values = vehicles?.map((vehicle) => {
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'transmission'
						)?.value || ''
					);
				});
				break;
			case 'DRIVELINE':
				values = vehicles?.map((vehicle) => {
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'normalDriveLine'
						)?.value || ''
					);
				});
				break;
			case 'BODY_SEATING':
				values = vehicles?.map((vehicle) => {
					const body =
						vehicle?.attributes?.find(
							(item) => item?.name === 'bodyStyle'
						)?.value || '';
					const seatCount = getSeats(vehicle?.equipment);
					const seatLabel = seatCount
						? `${seatCount} ${labels.get('SEATS')}`
						: '';
					return [body, seatLabel].filter((item) => item).join(' / ');
				});
				break;
			case 'ENGINE':
				values = vehicles?.map((vehicle) => {
					return (
						vehicle?.attributes?.find(
							(item) => item?.name === 'engine'
						)?.value || ''
					);
				});
				break;
			case 'EXTERIOR_COLOR':
				values = vehicles?.map((vehicle) => {
					return {
						text:
							vehicle?.attributes?.find(
								(item) => item?.name === 'exteriorColor'
							)?.value || '',
						color:
							vehicle?.attributes?.find(
								(item) => item?.name === 'exteriorColor'
							)?.normalizedValue || ''
					};
				});
				break;
			case 'INTERIOR_COLOR':
				values = vehicles?.map((vehicle) => {
					return {
						text:
							vehicle?.attributes?.find(
								(item) => item?.name === 'interiorColor'
							)?.value || '',
						color:
							vehicle?.attributes?.find(
								(item) => item?.name === 'interiorColor'
							)?.normalizedValue || ''
					};
				});
				break;
			case 'CONDITION':
				values = vehicles?.map((vehicle) => {
					const type = getVehicleType(vehicle);
					if (type === 'new')
						return labels.get('COMPARE_CONDITION_NEW') || '';
					if (type === 'certified')
						return labels.get('COMPARE_CONDITION_CERTIFIED') || '';
					if (type === 'used')
						return labels.get('COMPARE_CONDITION_PREOWNED') || '';
					return '';
				});
				break;
			default:
		}
		// Add element to vehiclesAttrs if some attributes in this values variable has value
		if (
			values.some((item) => {
				// If item is an array object
				if (typeof item === 'object') {
					return Object.values(item).some((val) => val !== '');
				}
				// If item is an array string
				return item !== '';
			})
		) {
			vehiclesAttrs.set(attribute, values);
		}
	});
	return vehiclesAttrs;
};
